// Get colors form the root
const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--brand-primary');
const primaryColorInvert = getComputedStyle(document.documentElement).getPropertyValue('--brand-primary-invert');
const primaryColorDeep = getComputedStyle(document.documentElement).getPropertyValue('--brand-primary-dark');
const primaryColorExtraLight = getComputedStyle(document.documentElement).getPropertyValue('--brand-primary-lighter');

// CONFIGS
const themeConfig = {
  theme: 'light', // options[String]: 'light'(default), 'dark', 'semi-dark'
  
  appPrimaryColor: primaryColor, // options[Boolean]: true, false(default)
  appPrimaryColorInvert: primaryColorInvert, // options[Boolean]: true, false(default)
  appPrimaryColorDeep: primaryColorDeep, // options[Boolean]: true, false(default)
  appPrimaryColorExtraLight: primaryColorExtraLight, // options[Boolean]: true, false(default)
  
  navbarColor: '#fff', // options[String]: HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
  navbarType: 'hidden', // options[String]: floating(default) / static / sticky / hidden
  footerType: 'static', // options[String]: static(default) / sticky / hidden
  routerTransition: 'zoom-fade', // options[String]: zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)

  // NOTE: themeTour will be disabled in screens < 1200. Please refer docs for more info.
};

export default themeConfig;
